import { render, staticRenderFns } from "./OneTap.vue?vue&type=template&id=34757708&scoped=true&"
import script from "./OneTap.vue?vue&type=script&lang=js&"
export * from "./OneTap.vue?vue&type=script&lang=js&"
import style0 from "./OneTap.vue?vue&type=style&index=0&id=34757708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34757708",
  null
  
)

/* custom blocks */
import block0 from "./OneTap.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports